import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	get() {
		return request({
			url: store.getters.getPostUrl + 'menu',
			method: 'get',
		})
	},
	add(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role',
			method: 'post',
			data: param
		})
	},
	getByOrganization(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role/byOrganization',
			method: 'post',
			data: param
		})
	},
	getParent(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/getParent',
			method: 'get',
			params: param
		})
	},
	edit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role',
			method: 'put',
			data: param
		})
	},
	updateMember(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role/updateMember',
			method: 'put',
			data: param
		})
	},
	updateState(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role/updateState',
			method: 'put',
			params: param
		})
	},
	sort(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role/sort',
			method: 'put',
			params: param
		})
	},
	remove(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role',
			method: 'delete',
			params: param
		})
	},
	copy(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/role/copy',
			method: 'post',
			data: param
		})
	},
  updateCheckAllOrNot(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/role/updateCheckAllOrNot',
      method: 'put',
      params: param
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/system/menuTab.js